import { useEffect, useState } from 'react';

/**
 * Плашка диагностики геолокации на прогулке — проверить слежение
 * на телефоне, где нет консоли. Включается и выключается пятью
 * быстрыми тапами по кнопке геолокации. Состояние — из `useWalkGeolocation`
 */
const GeoDebug = ({ geo }) => {
  const { geoDebug, getGeoDebugInfo, userPosition, userAccuracy } = geo;
  const [, setTick] = useState(0);

  // Возраст позиции растёт и без новых данных — перерисовываемся сами
  useEffect(() => {
    if (!geoDebug) return undefined;
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, [geoDebug]);

  if (!geoDebug) return null;

  const info = getGeoDebugInfo();
  const age = info.lastFixAt ? `${Math.round((Date.now() - info.lastFixAt) / 1000)} с` : '—';
  const rows = [
    ['платформа', info.platform],
    ['источник', info.source || '—'],
    ['слежение', info.watching ? 'идёт' : 'стоит'],
    ['блок', info.blocked ? 'да' : 'нет'],
    ['доступ', info.granted ? 'подтверждён' : 'нет'],
    ['запрос', info.pending ? 'ждёт ответа' : '—'],
    ['позиция', userPosition ? `${userPosition[0].toFixed(5)}, ${userPosition[1].toFixed(5)}` : '—'],
    ['точность', userAccuracy != null ? `${Math.round(userAccuracy)} м` : '—'],
    ['возраст', age],
    ['фиксы / промахи', `${info.fixes} / ${info.misses}`],
    ['таймауты', info.timeouts],
    ['перезапуски', info.restarts],
    ['повторы потери', info.lostRetries],
    ['ошибка', info.lastError || '—'],
  ];

  return (
    <div
      className="pointer-events-none fixed left-2 top-1/3 z-[2000] rounded-md px-2 py-1.5 font-mono text-[10px] leading-tight"
      style={{ background: 'rgba(0,0,0,0.75)', color: '#fff', maxWidth: '70vw' }}
    >
      {rows.map(([k, v]) => (
        <div key={k}><span style={{ opacity: 0.6 }}>{k}:</span> {String(v)}</div>
      ))}
    </div>
  );
};

export default GeoDebug;
